import { useVehicleCardContext } from 'components/card/Buyers/Context/vehicle-card.context';
import { BID_SALE_AUCTION_STATUS } from 'constants/bidSale';
import { SALE_TYPE, VEHICLE_STATUS } from 'constants/vehicle';
import { treatments } from 'helpers/split/treatments';
import useTreatments from 'hooks/useTreatments';

export const getVehicleSaleType = (vehicle) => {
	const saleType = vehicle?.offerData?.public?.general?.sale_type || vehicle?.sale_type;
	const isAuction = saleType === SALE_TYPE.auction;
	const isMarketplace = !isAuction;
	return { isAuction, isMarketplace };
};

export const isAuctionEngineVehicle = (vehicle) => Boolean(vehicle?.ae_auction_id);

export const getExclusivityPeriodDuration = (vehicle) => vehicle?.exclusivity_period_duration || 15;

export const isSold = (vehicle) => vehicle.status === VEHICLE_STATUS.sold || Boolean(vehicle.sold_at);

export const isExpired = (vehicle) => vehicle.status === VEHICLE_STATUS.expired;

export const useVehiclePreviewMode = () => {
	const { vehicle } = useVehicleCardContext();
	const tbd_2883_prevent_minimum_bids_in_pending_auctions = useTreatments(
		treatments.tbd_2883_prevent_minimum_bids_in_pending_auctions,
	);

	const pendingStatus =
		vehicle.bid_sale_auction_status === BID_SALE_AUCTION_STATUS.pending ||
		vehicle?.offerData?.public?.general?.status === BID_SALE_AUCTION_STATUS.pending;
	const auctionPreview = tbd_2883_prevent_minimum_bids_in_pending_auctions && pendingStatus;

	return auctionPreview;
};
